// @ts-check
import 'Styles/commonComponents/settings/logoBackgroundSetting.scss';
import { ShowAlert } from 'Utils/CommonFunctions';
import { Buffer } from 'buffer';
import { observer } from 'mobx-react';
import React, { useRef } from "react";

/**
 * @param {React.ChangeEvent<HTMLInputElement>} evnt 
 * @param {('logo' | 'background')} fileTarget
 * @param {(arg0: string) => void} setFileData
 */
const ReadFile = async (evnt, fileTarget, setFileData) => {
    let file = evnt.target.files?.item(0);
    if (!file)
        return;

    let maxFileSizeMb = fileTarget === 'logo' ? 2 : 4;
    let maxFileSizeBytes = maxFileSizeMb * Math.pow(1024, 2);
    if (file.size > maxFileSizeBytes) {
        ShowAlert('error',
            <div>
                Неподходящий вес изображения.<br />
                Не более {maxFileSizeMb}Мб.
            </div>
        );

        evnt.target.value = '';
        return;
    }

    let imageData = Buffer.from(await file.arrayBuffer()).toString('base64');

    let img = new Image;
    img.alt = 'img';

    img.onload = () => {
        let checkSizeResult = fileTarget === 'logo'
            ? img.width <= 512 && img.height <= 512 ? null : 'Максимальные размеры: 512 на 512 px.'
            : img.width === 2100 && img.height === 2100 ? null : 'Размер должен быть 2100 на 2100 px.';

        if (checkSizeResult == null) {
            setFileData(imageData);
        }
        else {
            ShowAlert('error',
                <div>
                    Неподходящий размер изображения.<br />
                    {checkSizeResult}
                </div>
            );
        }

        evnt.target.value = '';
    };

    img.onerror = () => {
        let textSource = fileTarget === 'logo'
            ? 'Логотип должен'
            : 'Фоновое изображение должно';

        ShowAlert('error',
            <div>
                Неподходящий формат изображения.<br />
                {textSource} быть в формате PNG или JPG.
            </div>
        );

        evnt.target.value = '';
    };

    img.src = `data:image;base64,${imageData}`;
};

/**
 * @param {{
 * logo: string | null,
 * logoChanged: (arg0: string | null) => void,
 * background: string | null,
 * backgroundChanged: (arg0: string | null) => void
 * }} props 
 * @returns {React.JSX.Element}
 */
const LogoBackgroundSetting = (props) => {
    let logoElement = props.logo == null ?
        <div className="logo-placeholder">Логотип не<br />назначен</div> :
        <img className='logo-image' src={`data:image;base64,${props.logo}`} alt="img" />;

    let backgroundElement = props.background == null ?
        <div className="logo-placeholder">Фоновое<br />изображение<br />рабочего стола<br />не назначено</div> :
        <img className='logo-image' src={`data:image;base64,${props.background}`} alt="img" />;

    /** @type {React.Ref<HTMLInputElement>} */
    let logoFileInputRef = useRef(null);

    let logoButton = props.logo == null ?
        <button onClick={() => logoFileInputRef.current?.click()}>Выберите файл</button> :
        <button onClick={() => props.logoChanged(null)} className='red-button'>Удалить файл</button>

    /** @type {React.Ref<HTMLInputElement>} */
    let backgroundFileInputRef = useRef(null);

    let backgroundButton = props.background == null ?
        <button onClick={() => backgroundFileInputRef.current?.click()}>Выберите файл</button> :
        <button onClick={() => props.backgroundChanged(null)} className='red-button'>Удалить файл</button>

    return (
        <div className='logo-background-setting'>

            <div className='logo-background-setting-block'>
                <div className='logo-background-setting-img'>
                    {logoElement}
                </div>
                <div className='logo-background-setting-container'>
                    <div className='logo-background-setting-description'>
                        Логотип должен быть в формате PNG или JPG c размером не более 512x512px и весом не более 2Мб.
                    </div>
                    {logoButton}
                    <input
                        ref={logoFileInputRef}
                        id='logo-file-input'
                        style={{ display: 'none' }}
                        type="file"
                        accept="image/png, image/jpeg"
                        onChange={e => ReadFile(e, 'logo', props.logoChanged)} />
                </div>
            </div>

            <div className='logo-background-setting-block'>
                <div className='logo-background-setting-img'>
                    {backgroundElement}
                </div>
                <div className='logo-background-setting-container'>
                    <div className='logo-background-setting-description'>
                        Фоновое изображение рабочего стола должно быть в формате PNG или JPG c размером 2100x2100px, не более 4Мб.
                    </div>
                    {backgroundButton}
                    <input
                        ref={backgroundFileInputRef}
                        id='background-file-input'
                        style={{ display: 'none' }}
                        type="file"
                        accept="image/png, image/jpeg"
                        onChange={e => ReadFile(e, 'background', props.backgroundChanged)} />
                </div>
            </div>
        </div>
    )
};

export default observer(LogoBackgroundSetting);